const optimizeTabs = {
    OVERVIEW: 'Overview',
    TIMELINE: 'Timeline',
    SETTINGS: 'Settings',
};

export default optimizeTabs;
